import React from 'react'

function QRDisOut() {
  return (
    <embed src="\pdfs\E1.4.1_Q-R_Rectangular_displacement_outlet_05.2012_kr.pdf" width="100%" height="2100px" />
  )
}

export default QRDisOut